/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import { useOptionalAIAgentMessage } from '../../AIAgentMessage/context';
import './DeflectionRendererStyles.scss';
export function DeflectionRenderer({ block }) {
    var _a, _b;
    const deflection = block;
    const agentMessage = useOptionalAIAgentMessage();
    const hasIntercomSuggestedAction = (_b = (_a = agentMessage === null || agentMessage === void 0 ? void 0 : agentMessage.envelope.suggested_actions) === null || _a === void 0 ? void 0 : _a.some((action) => action.action === 'open_intercom')) !== null && _b !== void 0 ? _b : false;
    const handleSupportLink = useCallback(() => {
        if (deflection.support_url) {
            window.open(deflection.support_url, '_blank', 'noopener,noreferrer');
        }
    }, [deflection.support_url]);
    const supportAction = deflection.support_url && !hasIntercomSuggestedAction
        ? [
            {
                id: 'support',
                label: deflection.support_label || 'Get Support',
                icon: 'fa-light fa-life-ring',
                onClick: handleSupportLink
            }
        ]
        : [];
    const sections = [
        {
            label: deflection.category,
            content: React.createElement(Text, { variant: "body" }, deflection.message),
            copyText: deflection.message
        },
        ...(deflection.examples.length > 0
            ? [
                {
                    content: (React.createElement("div", { className: "qmb-ui-DeflectionRenderer__examples" },
                        React.createElement(Text, { variant: "body" }, "Try asking:"),
                        React.createElement("ul", { className: "qmb-ui-DeflectionRenderer__example-list" }, deflection.examples.map((example, i) => (React.createElement("li", { key: i },
                            React.createElement(Text, { variant: "body" }, example)))))))
                }
            ]
            : [])
    ];
    return (React.createElement(AIGeneralBlockCard, { sections: sections, footerGroups: supportAction.length > 0 ? [{ actions: supportAction }] : [] }));
}
